import styled from "styled-components";
import { ReactComponent as ApproveIcon } from "src/images/approveTaskEditIcon.svg";
import { scrollbar } from "src/styles/mixins";

export const EditTaskPanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-items: space-between;
`;

export const EditTaskTextArea = styled.textarea`
  border: none;
  flex: 1;
  text-align: flex-start;
  outline: none;

  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};

  ${scrollbar}
`;

export const ApproveChangesIcon = styled(ApproveIcon)`
  width: fit-content;

  :hover {
    cursor: pointer;
  }
`;
